import { Injectable } from '@angular/core';
import { RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { AccountService } from 'app/core';
import { ObjectsManagerService } from 'app/modules/settings/objects-manager/services/objects-manager.service';
import { Observable, of, tap } from 'rxjs';
import { CustomObject } from './custom-objects.types';
import { Store } from '@ngxs/store';
import { ObjectsManagerActions } from 'app/modules/settings/objects-manager/state/actions';

@Injectable({
  providedIn: 'root',
})
export class CustomObjectsResolver {
  constructor(
    private readonly objectsManagerService: ObjectsManagerService,
    private readonly accountService: AccountService,
    private readonly store: Store,
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<CustomObject> {
    return this.objectsManagerService
      .getById(Number(this.accountService.getCurrentAccount().id), route.params.id || route.params.customObjectId)
      .pipe(
        tap((customObject) => {
          this.store.dispatch(new ObjectsManagerActions.SetCustomObject(customObject));
        }),
      );
  }
}
